<template>
  <section id="future-energy" class="o-section c-future" v-my-section-class>
    <div class="c-future__component">
      <component :is="currentView" @prosumer-active="onProsumerActive"></component>
    </div>
  </section>
</template>

<script>
import MyFutureMobile from '@/components/single/MyFutureMobile'
import MyFutureDesk from '@/components/single/MyFutureDesk'
import { MySectionClass } from '@/directives/my-section-class.js'
import { eventBus } from '@/main'
import 'waypoints/lib/noframework.waypoints'
import 'waypoints/lib/shortcuts/inview'

export default {
  name: 'my-future',
  data () {
    return {
      prosumerActive: false,
      waypoint: null,
      inview: false
    }
  },
  components: {
    MyFutureMobile,
    MyFutureDesk
  },
  directives: {
    MySectionClass
  },
  computed: {
    device () {
      return this.$store.state.device
    },
    currentView () {
      return this.device === 0 ? 'my-future-mobile' : 'my-future-desk'
    }
  },
  methods: {
    onProsumerActive (val) {
      this.prosumerActive = val
    }
  },
  mounted () {
    this.waypoint = new Waypoint.Inview({
      element: this.$el,
      enter: (direction) => {
        this.inview = true
        eventBus.$emit('section-inview', this.inview)
      },
      exited: (direction) => {
        this.inview = false
        eventBus.$emit('section-inview', this.inview)
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// MyFuture.vue?544b695d